import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ source, sourceUrl, altText, className, theme }) => {
  const imgSourceUrl = sourceUrl || source;
  return <img className={className} src={imgSourceUrl} alt={altText} style={theme} />;
};

Image.propTypes = {
  source: PropTypes.string,
  sourceUrl: PropTypes.string,
  altText: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.shape({}),
};

Image.defaultProps = {
  source: null,
  sourceUrl: null,
  altText: null,
  className: null,
  theme: {},
};

export default Image;
